import { createResourceCollection } from '@/request'
import { ResourceModel } from '@/request/types'

/**
 * Result of enqueueing the bill-extraction backfill for one or more profiles.
 *
 * API endpoint: POST /api/admin/backfill_bill_extraction/ (an action/RPC, not a REST resource —
 * driven via the collection's `useCreate`). Only the latest result is kept, so it uses a constant
 * computedId.
 */
export type AdminBillExtractionBackfillResource = {
  enqueued: number[]
  skipped_no_bill: number[]
  not_found: number[]
} & ResourceModel

export const adminBillExtractionBackfillCollection =
  createResourceCollection<AdminBillExtractionBackfillResource>({
    name: 'adminBillExtractionBackfill',
    computedId: () => 'result',
    selector: (state) => state.adminBillExtractionBackfill,
  })

export const adminBillExtractionBackfillReducer =
  adminBillExtractionBackfillCollection.slice.reducer
